export const CONFIG = {
	SENTRY_DSN: "https://741d41d6e18509791b642ab501238b1d@o363881.ingest.us.sentry.io/4508993784971264",
	SENTRY_ORG: "shapediver",
	SENTRY_PROJECT: "app-builder-ijewel3d",
	SENTRY_RELEASE_TIMESTAMP: "2026-07-08_15:14"
};